import { createStore } from 'vuex';
import { apiMixin } from '../mixin/apiMixin';

const store = createStore({
  	state: {
        user: null,
    	systemSettings: {
            hm_working_hours_start: '07:00',
            hm_working_hours_end: '17:00',
            hm_working_days: '1-6',
            currency: {
                code: 'GBP',
                symbol: '£',
                label: 'Pound'
            },
        },
        availableSchedules: [],
        bookedSchedules: [],
  	},
	mutations: {
		setSystemSettings(state, payload) {
			state.systemSettings = payload;
		},
        setUser(state, payload) {
            state.user = payload;
        },
        setAvailableSchedules(state, payload) {
            state.availableSchedules = payload;
        },
        setBookedSchedules(state, payload) {
            state.bookedSchedules = payload;
        },
	},
    getters: {
    	getSystemSettings: state => state.systemSettings,
        getUser: state => state.user,
        getAvailableSchedules: state => state.availableSchedules,
        getBookedSchedules: state => state.bookedSchedules,
  	},
	actions: {
		async fetchSystemSettings({ commit }) {
			try {
                const response = await apiMixin.methods.getSystemSettings();
                if(response.status === 'success') {
                    commit('setSystemSettings', response.settings);
                }
			} catch (error) {
				console.error('Error fetching system settings:', error);
			}
		},
        async fetchAvailableSchedules({ commit }, payload) {
            try {
                const response = await apiMixin.methods.getAvailableSchedules(payload);
                if(response.status === 'success') {
                    commit('setAvailableSchedules', response.schedules);
                }
            } catch (error) {
                console.error('Error fetching available schedule:', error);
            }
        },
        async fetchBookedSchedules({ commit }) {
            try {
                const response = await apiMixin.methods.getBookedSchedules();
                if(response.status === 'success') {
                    commit('setBookedSchedules', response.schedules);
                }
            } catch (error) {
                console.error('Error fetching booked schedule:', error);
            }
        },
        async fetchUserProfile({ commit }) {
            try {
                const response = await apiMixin.methods.getUserProfile();
                if(response && response.status === 'success') {
                    commit('setUser', response.user);

                    // Call actions to fetch system settings and available schedules
                    store.dispatch('fetchSystemSettings');
                    store.dispatch('fetchAvailableSchedules');
                }
            } catch (error) {
                console.error('Error fetching user profile:', error);
            }
        }
	}
});

// Request the data from the server

store.dispatch('fetchUserProfile');

export default store;
